import { createContext, FC } from "react";

import {
  ColumnOrderState,
  GroupingState,
  IColumnDef,
  IExtendableDto,
  OnChangeFn,
  RenderSubComponentModel,
  SortingState,
  VisibilityState,
} from "@ryde/shared";

import { IGridRowProps } from "../../core";

interface ITableWrapperContext {
  columnDefs: IColumnDef<IExtendableDto, unknown>[];
  groupingField?: string | number;
  columnGrouping: GroupingState;
  columnOrder: ColumnOrderState;
  columnSorting: SortingState;
  columnVisibility: VisibilityState | undefined;
  setColumnGrouping?: (groupingState: GroupingState) => void;
  setColumnOrder?: OnChangeFn<ColumnOrderState>;
  setColumnSorting?: OnChangeFn<SortingState>;
  setColumnVisibility?: OnChangeFn<VisibilityState>;
  renderSubComponent?: RenderSubComponentModel<IExtendableDto>;
  GridRowRenderer?: FC<IGridRowProps<IExtendableDto>>;
  /** Route facts computed once above the rows — rows read these instead of instantiating useRidesNavigation(). */
  isGridSingleSelectView: boolean;
  isRidesEditOrAddRoute: boolean;
  /** Prefixed edit href base for the id column (ends with `/edit/`); undefined keeps the imperative fallback. */
  idColumnEditHrefBase?: string;
  idColumnEditHrefSearch: string;
}

const defaultValue = {
  columnDefs: [],
  groupingValue: [],
  columnGrouping: [],
  columnOrder: [],
  columnSorting: [],
  columnVisibility: undefined,
  tableData: [],
  isGridSingleSelectView: false,
  isRidesEditOrAddRoute: false,
  idColumnEditHrefSearch: "",
};

export const TableWrapperContext =
  createContext<ITableWrapperContext>(defaultValue);
